import React, {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import axios from "axios";
import Layout from "app/hoc/Layout";
import RenderIf from "app/components/RenderIf";
import CreateVoidTicket from "./modals/CreateVoidTicket";
import Print from "../Tickets/modals/Print";
import Ticket from "app/modules/VoidTickets/components/Ticket";
import VoidTicketModal from "../VoidTickets/modals/VoidTicket";
import UpdateVoidTicket from "./modals/UpdateVoidTicket";
import PayVoidTicket from "../VoidTickets/modals/PayVoidTicket";
import {actions} from "../Tickets/_redux/ticketRedux";
import {actions as authActions} from "../Auth/_redux/authRedux";
import {actions as snackbarActions} from "app/hoc/Snackbar/snackbarRedux";
import PlayCirculation from "./components/PlayCirculation";
import AlertComponent from "../../../_metronic/_helpers/AlertComponent";
import Loading from "../../components/Loading";

const {setPrintData, setPrintType, setWinningPaid} = actions;
const {getProfile} = authActions;
const {setSnackbar} = snackbarActions;

function Circulations() {
    const [groups, setGroups] = useState([]);
    const [chooseGroupId] = useState(undefined);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState("");
    const [showBet, setShowBet] = useState(false);
    const [showPrint, setShowPrint] = useState(false);
    const [showVoidTicket, setShowVoidTicket] = useState(false);
    const [showUpdateVoidTicket, setShowUpdateVoidTicket] = useState(false);
    const [showPayVoidTicket, setShowPayVoidTicket] = useState(false);
    const [voidTicketData, setVoidTicketData] = useState(null);
    const [barcode, setBarcode] = useState("");
    const [errorBarcode, setErrorBarcode] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const dispatch = useDispatch();

    function handleShowPlay() {
        setShowBet((key) => !key);
    }

    const onGroups = () => {
        setIsLoading(true);
        axios
            .get(`circulations/filter`, {
                params: {
                    canBePlayed: true,
                    isActive: true,
                },
            })
            .then(({data: {data}}) => {
                setIsLoading(false);
                setGroups(data);
            })
            .catch(() => {
                setIsLoading(false);
                setGroups([]);
            });
    };

    const onCirculationChoose = (id) => {
        return axios.get(`circulations/circulationGames?id=${id}`);
    };

    function handleChangeBarcode(e) {
        if(!isSubmitting) {
            const value = e.target.value;
            setErrorBarcode(false);
            setShowVoidTicket(false);

            setBarcode(barcode => {
                if (barcode.length >= 17) {
                    setBarcode(value[17])
                } else {
                    setBarcode(value)
                }
            })
        }
    }

    async function handlePayVoidTicket() {
        try {
            const {data} = await axios({
                method: "PUT",
                url: "/voidTickets/paidTicket",
                data: {
                    ticketNumber: barcode,
                },
            });
            const {data: ticketData} = await axios({
                method: "GET",
                url: `tickets/byIdForAgent`,
                params: {
                    id: data,
                },
            });
            dispatch(setPrintData(ticketData));
            dispatch(setWinningPaid(false));
            const printType =
                ticketData.statusId === 0
                    ? 0
                    : ticketData.statusId === 2
                        ? 1
                        : ticketData.statusId === 4 && 2;
            dispatch(setPrintType(printType));
            dispatch(getProfile());
            dispatch(
                setSnackbar({
                    variant: "success",
                    message: "Mərc edildi!",
                })
            );
            setShowPayVoidTicket(false);
            setShowVoidTicket(false);
            setShowPrint(true);
        } catch (err) {
            const message = err.response?.data?.message;
            dispatch(
                setSnackbar({
                    variant: "error",
                    message,
                })
            );
        }
    }

    async function handleGetVoidTicket(barcode) {
        if (barcode?.length > 15) {
            try {
                setIsSubmitting(true);
                const {data} = await axios({
                    method: "GET",
                    url: "voidTickets/barcode",
                    params: {
                        ticketNumber: barcode,
                    },
                });
                setVoidTicketData(data);
                setShowVoidTicket(true);
                setError("");
            } catch (err) {
                const message = err?.response?.data?.message
                    ? err?.response?.data?.message
                    : "Xəta baş verdi.";
                setError(message);
            } finally {
                setIsSubmitting(false)
            }
        } else {
            setErrorBarcode(true);
        }
    }

    useEffect(() => {
        const getAllTimer = setTimeout(() => {
            onGroups();
        }, 500);
        return () => {
            clearTimeout(getAllTimer);
        };
    }, []);

    return (
        <Layout>
            <Ticket
                onBarcode={handleChangeBarcode}
                barcode={barcode}
                onTicket={handleGetVoidTicket}
                setBarcode={setBarcode}
                setErrorBarcode={setErrorBarcode}
                errorBarcode={errorBarcode}
                setShowVoidTicket={setShowVoidTicket}
                isSubmitting={isSubmitting}
            />

            <RenderIf condition={error}>
                <div className="w-100 d-flex justify-content-center">
                    <span className="error">{error}</span>
                </div>
            </RenderIf>
            {isLoading ? <div className='w-100 d-flex justify-content-center'><Loading/></div>
                : Boolean(groups.length) ? (
                <div className="w-100 d-flex justify-content-center">
                    <PlayCirculation circulations={groups} setShowPrint={setShowPrint} refetch={onGroups}/>
                </div>
            ) : (
                <AlertComponent variant="info" message="Hazırda aktiv tur yoxdur."/>
            )}
            <RenderIf condition={showBet}>
                <CreateVoidTicket
                    show={showBet}
                    onHide={handleShowPlay}
                    onCirculationChoose={onCirculationChoose}
                    id={chooseGroupId}
                    isLoading={isLoading}
                    setIsLoading={setIsLoading}
                    setShowBet={setShowBet}
                    setShowPrint={setShowPrint}
                />
            </RenderIf>
            <RenderIf condition={showPrint}>
                <Print show={showPrint} onHide={setShowPrint}/>
            </RenderIf>
            <RenderIf condition={showVoidTicket}>
                <VoidTicketModal
                    show={showVoidTicket}
                    onHide={setShowVoidTicket}
                    data={voidTicketData}
                    handlePayVoidTicket={handlePayVoidTicket}
                />
            </RenderIf>
            <RenderIf condition={showUpdateVoidTicket}>
                <UpdateVoidTicket
                    show={showUpdateVoidTicket}
                    onHide={setShowUpdateVoidTicket}
                    barcode={barcode}
                    setBarcode={setBarcode}
                    isLoading={isLoading}
                    setIsLoading={setIsLoading}
                    onGetVoidTicket={handleGetVoidTicket}
                    setShowVoidTicket={setShowVoidTicket}
                    data={voidTicketData}
                />
            </RenderIf>
            <RenderIf condition={showPayVoidTicket}>
                <PayVoidTicket
                    show={showPayVoidTicket}
                    onHide={setShowPayVoidTicket}
                    putPaidTicket={handlePayVoidTicket}
                />
            </RenderIf>
        </Layout>
    );
}

export default Circulations;
